export default "__VITE_ASSET__b38593e5__"